import React from "react";

import styles from "./RegionSelector.style";
import {
  Panel,
  PanelHeader,
  List,
  Group,
  PanelHeaderBack,
  ScreenSpinner,
  Div,
} from "@vkontakte/vkui";
import Icon24Done from "@vkontakte/icons/dist/24/done";
import { SimpleCell } from "@vkontakte/vkui";
import { panels } from "../../variables";
import { setActivePanel, setPreviousPanel } from "../../redux/actions/panelsActions";
import { connect } from "react-redux";
import PanelHeaderButton from "@vkontakte/vkui/dist/components/PanelHeaderButton/PanelHeaderButton";
import Icon28Search from "@vkontakte/icons/dist/28/search";
import {
  selectMedicalOrganisation,
  selectRegion,
  startFourthStepLoading,
} from "../../redux/actions/regionAndMedicalOrganisationActions";

const RegionSelector = ({
  regions,
  selectedRegion,
  goBack,
  goToSearchPanel,
  selectRegion,
  startFourthStepLoading,
}) => {
  const mapRegionToSimpleCell = (region) => {
    return (
      <SimpleCell
        key={region.regionCode}
        onClick={() => {
          selectRegion(region);
          startFourthStepLoading(region.OKATO);
          goBack();
        }}
        after={
          selectedRegion.name === region.name ? (
            <Icon24Done fill="var(--accent)" />
          ) : null
        }
      >
        {region.name}
      </SimpleCell>
    );
  };
  return (
    <Panel id={panels.regions}>
      <PanelHeader
        left={<PanelHeaderBack onClick={() => goBack()} />}
        right={
          <PanelHeaderButton onClick={() => goToSearchPanel()}>
            <Icon28Search />
          </PanelHeaderButton>
        }
      >
        <span style={styles.blue}>ГОС</span>
        <span style={styles.red}>УСЛУГИ</span>
      </PanelHeader>
      {regions ? (
        <Group>
          <List>{regions ? regions.map(mapRegionToSimpleCell) : null}</List>
        </Group>
      ) : (
        <Div style={{ marginTop: "40vh" }}>
          <ScreenSpinner />
        </Div>
      )}
    </Panel>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedRegion: state.regionAndMedicalOrganisation.selectedRegion,
    regions: state.regionAndMedicalOrganisation.regions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goBack: () => dispatch(setPreviousPanel()),
    selectRegion: (region) => {
      dispatch(selectRegion(region));
      dispatch(selectMedicalOrganisation(null));
    },
    startFourthStepLoading: (regionOKATO) =>
      dispatch(startFourthStepLoading(regionOKATO)),
    goToSearchPanel: () => dispatch(setActivePanel(panels.regionSearchPanel)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RegionSelector);
